import { connect } from 'react-redux'
import { compose } from 'recompose'
import { isRegionsPage } from 'src/helpers/utils'
import { getPageLocation } from 'selectors'

const mapStateToProps = (state) => {
  const pageLocation = getPageLocation(state)


  return {
    isRegionPage: isRegionsPage(pageLocation)
  }
}

export default compose(
  connect(mapStateToProps, null)
)
